import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../../selectors/pages/vip/cashback/monthly';
import {redeemCashback} from '../../../../../reducers/vip/actions';
import ModalsLib from '../../../../../lib/modals';
import Numeric from '../../../../components/numeric';
import Timer from './timer';
import BlueButton from '../../../../components/blue-button';

export default () => {
    const {profile, button, level} = useSelector(Selector),
          dispatch = useDispatch();

    return (
        <div className="cashback monthly">
            <div className="title">MONTHLY</div>
            <div className="details">
                <div className="amount">
                    <Numeric value={profile.amount} fixedDecimalScale={0} />
                    BOOST
                </div>
                <div className="royalty">
                    Cashback {level ? <span>{level.preset.cashback.monthly}%</span> : <span>N/A</span>}
                </div>
            </div>

            {profile.status === 0 ? (
                <BlueButton active={false} className="cashback-button" onClick={e => {
                    ModalsLib.open('wallet');
                }}>
                    Add Cash
                </BlueButton>
            ) : (
                <Timer timestamp={profile.timestamp} timer_key={`vip_cashback_monthly`}>
                    <BlueButton active={button} className="cashback-button" onClick={e => {
                        if(button)
                            return;

                        dispatch(redeemCashback('monthly'))
                    }}>
                        Redeem <Numeric value={profile.amount} fixedDecimalScale={0} />
                    </BlueButton>
                </Timer>
            )}
        </div>
    )
}